<template>
    <div id="ag-grid-demo">
        <vx-card :title="$t('Projects')">

            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                    <vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ projects.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : projects.length }} of {{ projects.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(200)">
                                <span>200</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(300)">
                                <span>300</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(500)">
                                <span>500</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                </div>


                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                    <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
                </div>
            </div>

            <ag-grid-vue
                    ref="agGridTable"
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="projects"
                    colResizeDefault="shift"
                    :animateRows="true"
                    domLayout="autoHeight"
                    :floatingFilter="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true">
            </ag-grid-vue>
            <vs-pagination
                    :total="totalPages"
                    :max="maxPageNumbers"
                    v-model="currentPage" />

        </vx-card>
    </div>
</template>
<script>

    import { AgGridVue } from "ag-grid-vue"
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import TimeRenderer from "./Task/TimeRenderer";
    import StatusRenderer from "./Task/StatusRenderer";
    import ProjectStatusRenderer from "./Project/ProjectStatusRenderer";

    export default {
        components: {
            AgGridVue,
            TimeRenderer,
            StatusRenderer,
            ProjectStatusRenderer
        },
        data() {
            return {

                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        this.$router.push({ name: 'project', params: { id: "" + e.data.id } })
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns(['name', 'project_leader', 'status', 'total_tasks', 'finished_tasks', 'completed_percent', 'offer_id']);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                    }
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [
                    {
                        headerName: this.$t("Name"),
                        field: 'name',
                        filter: true,
                    },
                    {
                        headerName: this.$t("ProjectLeader"),
                        field: 'project_leader',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Status"),
                        field: 'status',
                        filter: true,
                        valueGetter: this.statusValueGetter,
                        cellRendererFramework: ProjectStatusRenderer,
                    },
                    {
                        headerName: this.$t("TotalTasks"),
                        field: 'total_tasks',
                        filter: true,
                    },
                    {
                        headerName: this.$t("FinishedTasks"),
                        field: 'finished_tasks',
                        filter: true,
                    },
                    {
                        headerName: this.$t("CompletedPercent"),
                        field: 'completed_percent',
                        filter: true,
                        valueGetter: this.projectPercentGetter,
                    },
                    {
                        headerName: this.$t("OfferId"),
                        field: 'offer_id',
                        filter: true,
                    },
                ],
                projects: [],

            }
        },
        computed: {
            displayTaskList() {
                return this.tasks
            },
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                if(state){
                    for(let x = 0; x < state.length; x++){
                        total += state[x].width
                    }
                }

                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    if(this.gridApi){
                        this.gridApi.paginationGoToPage(val - 1)
                    }

                }
            },
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(['name', 'project_leader', 'status', 'total_tasks', 'finished_tasks', 'completed_percent', 'offer_id']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateProjects() {

                const thisIns = this;
                this.$http.get('/api/v1/project/')
                    .then(function (response) {
                        thisIns.projects = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            statusValueGetter(param){
                switch (param.data.status) {
                    case 0:
                        return this.$t("InProgress");
                    case 1:
                        return this.$t("SentForConfirmation");
                    case 2:
                        return this.$t("SentForConfirmation");
                    case 3:
                        return this.$t("Confirmed");
                    case 4:
                        return this.$t("Confirmed");
                    case 5:
                        return this.$t("Confirmed");
                    case 6:
                        return this.$t("Confirmed");
                    default:
                        return ""

                }
            },
            projectPercentGetter(param){
                return param.data.completed_percent + "%"
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
            this.updateProjects();
        },
    }

</script>
